/**
 * Structured logger for client-side code
 * Provides debug/info/warn/error levels with consistent formatting
 */

const IS_DEV = import.meta.env?.DEV ?? false;

export const logger = {
  debug: (context: string, message: string, data?: unknown) => {
    if (IS_DEV) {
      console.log(`[DEBUG][${context}] ${message}`, data !== undefined ? data : "");
    }
  },

  info: (context: string, message: string, data?: unknown) => {
    console.log(`[INFO][${context}] ${message}`, data !== undefined ? data : "");
  },

  warn: (context: string, message: string, data?: unknown) => {
    console.warn(`[WARN][${context}] ${message}`, data !== undefined ? data : "");
  },

  error: (context: string, message: string, error?: unknown) => {
    console.error(`[ERROR][${context}] ${message}`, error !== undefined ? error : "");
  },
};

export default logger;
